import { render } from "./GoalCountChip.vue?vue&type=template&id=3be3d181"
import script from "./GoalCountChip.vue?vue&type=script&lang=js"
export * from "./GoalCountChip.vue?vue&type=script&lang=js"
script.render = render

export default script